<template>
  <div class="tb-ticket">
    <div
      v-for="(number, index) in cells"
      :key="index"
      class="tb-ticket__cell"
      :class="{ 'is-blank': !number, 'is-marked': !!number && markedSet.has(number) }"
    >
      {{ number || "" }}
    </div>
  </div>
</template>

<script>
  import { TICKET_ROWS, TICKET_COLS, ticketIndex } from "../constants/game";

  /**
   * The 3x9 grid of a single tambola ticket. Cells are laid out row by row so
   * CSS Grid can size them, which is why the sparse column-major storage has
   * to be flattened here.
   */
  export default {
    name: "TicketGrid",
    props: {
      card: {
        type: [Object, Array],
        required: true
      },
      // Numbers already called; rendered as struck through / highlighted.
      marked: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      cells() {
        const cells = [];
        for (let row = 1; row <= TICKET_ROWS; row++) {
          for (let column = 1; column <= TICKET_COLS; column++) {
            cells.push(this.card[ticketIndex(row, column)]);
          }
        }
        return cells;
      },
      // A Set turns the per-cell lookup from O(called) into O(1); with 90
      // numbers and dozens of tickets on screen that adds up.
      markedSet() {
        return new Set(this.marked);
      }
    }
  };
</script>
